import { render, staticRenderFns } from "./NotificationBuild.vue?vue&type=template&id=816e8134&"
import script from "./NotificationBuild.vue?vue&type=script&lang=js&"
export * from "./NotificationBuild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports